import React from 'react';

function TableView({ data }) {
    const visibleKeys = ['Lon', 'Lat', 'FV1', 'Speed', 'GT', 'RT'];

    return (
        <div className="overflow-auto">
            <table className="min-w-full text-sm border">
                <thead className="bg-gray-100">
                    <tr>
                        {visibleKeys.map((key) => (
                            <th key={key} className="border px-2 py-1">{key}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {data.length === 0 ? (
                        <tr>
                            <td colSpan={visibleKeys.length} className="text-center py-2">📭 No Data</td>
                        </tr>
                    ) : (
                        data.map((item, idx) => (
                            <tr key={idx}>
                                {visibleKeys.map((key) => (
                                    <td key={key} className="border px-2 py-1">
                                        {item[key] !== undefined && item[key] !== null ? item[key] : '📭'}
                                    </td>
                                ))}
                            </tr>
                        ))
                    )}
                </tbody>
            </table>
        </div>
    );
}

export default TableView;
